/**
 * Single Taupe Write-a-review button → popup that actually hosts the Yotpo form.
 */
(function () {
  const NATIVE_WRITE = [
    '.write-review',
    '.yotpo-default-button.write-review',
    'button.write-review',
    'a.write-review',
    '.yotpo-new-review-btn',
    '[data-button-type="write"]',
    'button[class*="write-review"]',
    'a[class*="write-review"]',
  ].join(',');

  function qsa(sel, root) {
    try {
      return Array.from((root || document).querySelectorAll(sel));
    } catch (e) {
      return [];
    }
  }

  function isVisible(el) {
    if (!el || el.nodeType !== 1) return false;
    const style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
    const rect = el.getBoundingClientRect();
    return rect.width > 0 || rect.height > 0 || el.querySelector('input, textarea, select');
  }

  function fieldCount(el) {
    if (!el) return 0;
    return el.querySelectorAll(
      'textarea, input[type="text"], input[type="email"], input:not([type="hidden"]):not([type="submit"]):not([type="button"]):not([type="checkbox"]):not([type="radio"]):not([type="file"])'
    ).length;
  }

  function findNativeWrite(section) {
    const nodes = qsa(NATIVE_WRITE, section).concat(qsa(NATIVE_WRITE, document));
    for (const node of nodes) {
      if (!node || node.id === 'TaupeYotpoWriteBtn' || node.closest('.taupe-yotpo-popup')) continue;
      return node;
    }
    const loose = qsa('button, a, [role="button"], .yotpo-default-button', section).concat(
      qsa('button, a, [role="button"], .yotpo-default-button', document)
    );
    for (const node of loose) {
      if (!node || node.id === 'TaupeYotpoWriteBtn' || node.closest('.taupe-yotpo-popup')) continue;
      const text = (node.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (text.includes('write a review') || text === 'write review' || text.includes('leave a review')) {
        return node;
      }
    }
    return null;
  }

  function findFormCandidate(section) {
    const selectors = [
      '.yotpo-modal .yotpo-modal-dialog',
      '.yotpo-modal .yotpo-modal-content',
      '.yotpo-modal-dialog',
      '.yotpo-modal-content',
      '.yotpo-modal-body',
      '.yotpo-regular-box',
      '.yotpo-form-wrapper',
      '.yotpo-review-form',
      'form.yotpo-form',
      '.yotpo-new-review-form',
      '[class*="yotpo"][class*="ReviewForm"]',
      '[class*="yotpo"][class*="review-form"]',
      'form[class*="yotpo"]',
      '[role="dialog"] form',
    ];

    let best = null;
    let bestScore = 0;

    for (const sel of selectors) {
      for (const node of qsa(sel, document)) {
        if (!node || node.closest('#TaupeYotpoPopupFormHost')) continue;
        if (isReviewsListOrSearch(node) && !node.closest('.yotpo-modal')) continue;
        // Prefer nodes that are currently shown by Yotpo, or recently injected
        const score = fieldCount(node) * 10 + (isVisible(node) ? 5 : 0) + (node.closest('.yotpo-modal') ? 3 : 0);
        if (score > bestScore) {
          best = node;
          bestScore = score;
        }
      }
    }

    // Last resort: any yotpo container with enough fields that appeared recently
    if (!best || bestScore < 10) {
      for (const node of qsa('.yotpo, [class*="yotpo"]', document)) {
        if (!node || node.closest('#TaupeYotpoPopupFormHost') || node.closest('#TaupeYotpoPopup')) continue;
        if (isReviewsListOrSearch(node)) continue;
        const score = fieldCount(node);
        if (score >= 2 && score * 10 > bestScore) {
          best = node;
          bestScore = score * 10;
        }
      }
    }

    return bestScore >= 10 ? best : null;
  }

  function setLoading(host, on) {
    if (!host) return;
    let tip = host.querySelector('.taupe-yotpo-popup__loading');
    if (on) {
      if (!tip) {
        tip = document.createElement('p');
        tip.className = 'taupe-yotpo-popup__loading';
        tip.textContent = 'Loading review form…';
        host.prepend(tip);
      }
    } else if (tip) {
      tip.remove();
    }
  }

  function liveFormRoot() {
    return document.querySelector('.yotpo-modal.taupe-yotpo-modal-live') || document.getElementById('TaupeYotpoPopupFormHost');
  }

  function adoptedForm() {
    const host = document.getElementById('TaupeYotpoPopupFormHost');
    return (
      host?.querySelector('[data-taupe-yotpo-home="1"]') ||
      document.querySelector('[data-taupe-yotpo-home="1"]') ||
      null
    );
  }

  function parkFormInYotpo() {
    const form = adoptedForm();
    if (form?._taupeHomeMarker?.parentNode) {
      form._taupeHomeMarker.parentNode.insertBefore(form, form._taupeHomeMarker);
    }
    return form;
  }

  function returnFormToPopup() {
    const host = document.getElementById('TaupeYotpoPopupFormHost');
    const form = adoptedForm();
    if (!host || !form || form.parentElement === host) return form;
    host.appendChild(form);
    return form;
  }

  function findNativeSubmit(root) {
    const scope = root || document;
    const nodes = qsa(
      '.yotpo-submit, button.yotpo-submit, input.yotpo-submit, input[type="submit"], button[type="submit"], .yotpo-default-button',
      scope
    );
    for (const node of nodes) {
      if (node.closest('.taupe-social-row') || node.classList.contains('taupe-social-btn')) continue;
      if (node.id === 'TaupeYotpoWriteBtn' || node.id === 'TaupeYotpoPostBtn') continue;
      const text = `${node.value || ''} ${node.textContent || ''}`.replace(/\s+/g, ' ').trim().toLowerCase();
      if (!text || /post|submit|send|publish/.test(text) || node.classList.contains('yotpo-submit')) {
        return node;
      }
    }
    return nodes[0] || null;
  }

  function hideNativeSubmitButtons(root) {
    if (!root) return;
    qsa(
      '.yotpo-submit, input[type="submit"], input[type="button"].yotpo-submit, button[type="submit"], button.yotpo-submit, .yotpo-default-button.yotpo-submit, .yotpo-submit-wrapper .yotpo-default-button',
      root
    ).forEach((node) => {
      if (!node || node.id === 'TaupeYotpoPostBtn') return;
      node.classList.add('taupe-yotpo-native-submit');
      node.setAttribute('aria-hidden', 'true');
    });
  }

  function setPostBusy(isBusy) {
    const btn = document.getElementById('TaupeYotpoPostBtn');
    if (!btn) return;
    btn.disabled = !!isBusy;
    btn.textContent = isBusy ? 'Posting...' : 'Post';
  }

  function looksLikeSuccessText(text) {
    const normalized = String(text || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
    if (!normalized) return false;
    return (
      normalized.includes('thank you') ||
      normalized.includes('thanks for submitting') ||
      normalized.includes('review was posted') ||
      normalized.includes('review has been posted') ||
      normalized.includes('review submitted') ||
      normalized.includes('already been submitted')
    );
  }

  function hasSuccessState() {
    const selectors = [
      '.yotpo-thank-you',
      '.yotpo-success',
      '.yotpo-form-success',
      '.yotpo-message-success',
      '.submission-confirmation',
      '[class*="thank-you"]',
      '[class*="success"]',
    ];
    for (const selector of selectors) {
      for (const node of qsa(selector, document)) {
        if (isVisible(node) && looksLikeSuccessText(node.textContent)) return true;
      }
    }

    const host = document.getElementById('TaupeYotpoPopupFormHost');
    const scopes = [host, document.body].filter(Boolean);
    for (const scope of scopes) {
      for (const node of qsa('div, p, span, strong, li', scope)) {
        if (!isVisible(node)) continue;
        if (looksLikeSuccessText(node.textContent)) return true;
      }
    }
    return false;
  }

  function registerScoreWithYotpo(score) {
    const form = parkFormInYotpo() || liveFormRoot();
    applyScore(form || document, score);
    const star =
      (form || document).querySelector(`.review-star[data-score="${score}"]`) ||
      (form || document).querySelector(`.rating-star[data-score="${score}"]`);
    try {
      star?.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      star?.click();
    } catch (err) {}
    returnFormToPopup();
  }

  let yotpoSubmitBusy = false;

  function submitYotpoReview() {
    if (yotpoSubmitBusy) return true;
    yotpoSubmitBusy = true;
    setPostBusy(true);

    const host = document.getElementById('TaupeYotpoPopupFormHost');
    const score = (host || document).querySelectorAll('.taupe-star-picker__star.is-on').length;
    if (score > 0) registerScoreWithYotpo(score);

    const form = parkFormInYotpo() || liveFormRoot();
    const submit = findNativeSubmit(form) || findNativeSubmit(document);
    if (!submit) {
      yotpoSubmitBusy = false;
      setPostBusy(false);
      returnFormToPopup();
      return false;
    }
    submit.style.setProperty('pointer-events', 'auto', 'important');
    try {
      submit.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      submit.click();
    } catch (err) {
      try {
        submit.click();
      } catch (e) {}
    }

    let attempts = 0;
    const maxAttempts = 20;
    const checkResult = () => {
      attempts += 1;
      const popup = document.getElementById('TaupeYotpoPopup');
      if (!popup?.classList.contains('is-open')) {
        yotpoSubmitBusy = false;
        setPostBusy(false);
        return;
      }
      if (hasSuccessState()) {
        yotpoSubmitBusy = false;
        setPostBusy(false);
        closePopup();
        return;
      }
      if (attempts >= maxAttempts) {
        yotpoSubmitBusy = false;
        setPostBusy(false);
        returnFormToPopup();
        const back = document.getElementById('TaupeYotpoPopupFormHost');
        if (back) {
          polishForm(back);
          ensureTaupeStars(back);
          ensureTaupePost(back);
        }
        return;
      }
      window.setTimeout(checkResult, 250);
    };
    window.setTimeout(checkResult, 300);
    return true;
  }

  function ensureTaupePost(root) {
    const host = document.getElementById('TaupeYotpoPopupFormHost');
    const popup = document.getElementById('TaupeYotpoPopup');
    if (!host || !popup) return;
    let btn = document.getElementById('TaupeYotpoPostBtn');
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.id = 'TaupeYotpoPostBtn';
      btn.className = 'taupe-yotpo-post-btn';
      btn.textContent = 'Post';
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        submitYotpoReview();
      });
      const dialog = popup.querySelector('.taupe-yotpo-popup__body') || host.parentElement;
      dialog?.appendChild(btn);
    }
    btn.hidden = false;
    setPostBusy(false);
    hideNativeSubmitButtons(root || host);
  }

  function findScoreInput(root) {
    if (!root) return null;
    return (
      root.querySelector(
        'input[name="review_score"], input[name="score"], input[name="reviewScore"], input.yotpo-review-score, input[class*="review-score"], input[type="hidden"][name*="score" i]'
      ) || null
    );
  }

  function applyScore(root, score) {
    if (!root || !score) return;
    const input = findScoreInput(root);
    if (input) {
      input.value = String(score);
      input.setAttribute('value', String(score));
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    qsa('.review-star, .rating-star', root).forEach((star) => {
      const n = parseInt(star.getAttribute('data-score') || star.dataset.score || '0', 10);
      if (!n) return;
      const on = n <= score;
      star.classList.add('yotpo-icon', 'review-star');
      star.classList.toggle('yotpo-icon-star', on);
      star.classList.toggle('yotpo-icon-empty-star', !on);
      star.setAttribute('aria-checked', on && n === score ? 'true' : 'false');
      star.setAttribute('tabindex', n === score ? '0' : '-1');
    });

    root.querySelectorAll('.taupe-star-picker__star').forEach((btn, i) => {
      btn.classList.toggle('is-on', i < score);
      btn.setAttribute('aria-pressed', i < score ? 'true' : 'false');
    });
  }

  function ensureTaupeStars(root) {
    if (!root) return;

    if (!root.querySelector('.taupe-star-picker')) {
      const picker = document.createElement('div');
      picker.className = 'taupe-star-picker';
      picker.setAttribute('role', 'radiogroup');
      picker.setAttribute('aria-label', 'Score');
      for (let i = 1; i <= 5; i += 1) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'taupe-star-picker__star';
        btn.setAttribute('aria-label', i === 1 ? '1 star' : `${i} stars`);
        btn.textContent = '★';
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          applyScore(root, i);
          registerScoreWithYotpo(i);
        });
        picker.appendChild(btn);
      }

      const nativeBox =
        root.querySelector('.stars-wrapper')?.parentElement ||
        root.querySelector('[role="radiogroup"]:has(.review-star)') ||
        root.querySelector('.yotpo-review-stars');
      if (nativeBox && nativeBox.parentElement) {
        nativeBox.parentElement.insertBefore(picker, nativeBox);
      } else {
        let label = null;
        qsa('label, .y-label, span, p, div', root).forEach((el) => {
          const t = (el.textContent || '').replace(/\s+/g, ' ').trim();
          if (/^score/i.test(t) && t.length < 90) label = el;
        });
        if (label) label.insertAdjacentElement('afterend', picker);
        else root.prepend(picker);
      }
    }

    if (root.dataset.taupeSubmitBound !== '1') {
      root.dataset.taupeSubmitBound = '1';
      root.addEventListener(
        'click',
        (e) => {
          const btn = e.target.closest?.(
            '.yotpo-submit, button[type="submit"], input[type="submit"], input[type="button"].yotpo-default-button'
          );
          if (!btn || btn.closest('.taupe-social-row') || btn.classList.contains('taupe-social-btn')) return;
          if (btn.id === 'TaupeYotpoPostBtn') return;
          if (yotpoSubmitBusy) return;
          e.preventDefault();
          e.stopPropagation();
          submitYotpoReview();
        },
        true
      );
    }

    if (root.dataset.taupeStarsBound === '1') return;
    root.dataset.taupeStarsBound = '1';
    root.addEventListener(
      'click',
      (e) => {
        if (e.target.closest?.('.taupe-star-picker__star')) return;
        const star = e.target.closest?.('.review-star, .rating-star');
        if (!star) return;
        const score = parseInt(star.getAttribute('data-score') || star.dataset.score || '0', 10);
        if (score >= 1 && score <= 5) applyScore(root, score);
      },
      true
    );
  }

  function resolveAdoptTarget(form) {
    if (!form) return null;
    // Never hoist the whole reviews widget — that leaves the popup empty.
    const modal = form.closest?.('.yotpo-modal');
    if (modal) {
      const dialog =
        modal.querySelector('.yotpo-modal-dialog, .yotpo-modal-content, .yotpo-modal-body, .yotpo-regular-box, form');
      if (dialog && fieldCount(dialog) >= 2) return dialog;
    }
    const inner =
      form.querySelector?.('.yotpo-regular-box, .yotpo-form-wrapper, .yotpo-review-form, form') || null;
    if (inner && fieldCount(inner) >= fieldCount(form) && fieldCount(inner) >= 2) return inner;
    return form;
  }

  function adoptIntoPopup(form, section) {
    const popup = document.getElementById('TaupeYotpoPopup');
    const host = document.getElementById('TaupeYotpoPopupFormHost');
    if (!popup || !host || !form) return false;

    const target = resolveAdoptTarget(form);
    if (!target) return false;

    if (target.parentElement !== host) {
      if (!target.dataset.taupeYotpoHome) {
        const marker = document.createComment('taupe-yotpo-form-home');
        target.parentNode?.insertBefore(marker, target);
        target.dataset.taupeYotpoHome = '1';
        target._taupeHomeMarker = marker;
      }
      host.appendChild(target);
    }
    target.classList.add('taupe-yotpo-adopted');

    target.hidden = false;
    target.style.setProperty('display', 'flex', 'important');
    target.style.setProperty('visibility', 'visible', 'important');
    target.style.setProperty('opacity', '1', 'important');
    target.style.setProperty('width', '100%', 'important');
    target.style.setProperty('max-width', '100%', 'important');
    target.style.setProperty('position', 'static', 'important');
    target.style.setProperty('transform', 'none', 'important');
    target.style.setProperty('pointer-events', 'auto', 'important');

    qsa('input, textarea, select, label, button, .form-group, .yotpo-form-group, .yotpo-field', target).forEach((el) => {
      if (el.matches?.('.write-review, .yotpo-new-review-btn, .yotpo-close, .modal-close')) return;
      if (el.classList.contains('taupe-yotpo-empty-notice')) return;
      if (el.classList.contains('yotpo-submit-error') || el.closest('.yotpo-submit-error')) return;
      el.hidden = false;
      if (el.matches('input, textarea, select, label, button') || fieldCount(el)) {
        el.style.setProperty(
          'display',
          el.matches('label') ? 'block' : el.matches('button, input[type="submit"], .yotpo-submit') ? 'flex' : 'block',
          'important'
        );
      }
      el.style.setProperty('visibility', 'visible', 'important');
      el.style.setProperty('opacity', '1', 'important');
    });

    polishForm(host);
    ensureTaupeStars(host);
    ensureTaupePost(host);
    hideNativeSubmitButtons(host);
    window.setTimeout(() => {
      polishForm(host);
      ensureTaupeStars(host);
      ensureTaupePost(host);
      hideNativeSubmitButtons(host);
    }, 200);
    window.setTimeout(() => {
      polishForm(host);
      ensureTaupeStars(host);
      ensureTaupePost(host);
      hideNativeSubmitButtons(host);
    }, 600);

    setLoading(host, false);
    popup.classList.add('is-open');
    popup.classList.remove('is-yotpo-native');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('taupe-yotpo-popup-open');
    section?.classList.add('taupe-yotpo--popup-ready');
    return fieldCount(host) > 0;
  }

  let polishing = false;

  function isReviewsListOrSearch(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.matches?.('.yotpo-main-widget, .yotpo-widget-instance, [class*="yotpo-search"]')) return true;
    if (el.querySelector?.('input[type="search"], [class*="yotpo-search"]')) return true;
    if ((el.querySelectorAll?.('.yotpo-review, .yotpo-review-wrapper') || []).length > 1) return true;
    return false;
  }

  function ownText(el) {
    return Array.from(el.childNodes || [])
      .filter((n) => n.nodeType === 3)
      .map((n) => n.textContent || '')
      .join(' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function hideYotpoBranding(root) {
    if (!root) return;
    qsa('a, div, span, p, small', root).forEach((el) => {
      if (el.querySelector('input, textarea, select, button, label')) return;
      const text = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (!text || text.length > 28) return;
      if (text === 'powered by yotpo' || text === 'powered by' || /^powered by\s+yotpo/.test(text)) {
        el.style.setProperty('display', 'none', 'important');
      }
    });
  }

  const YOTPO_ERROR_LINES = [
    "question's body can't be empty",
    "question's body cannot be empty",
    "review's title & body can't be empty",
    "review's title and body can't be empty",
    "please enter a star rating for this review",
    'name field cannot be empty',
    'invalid email',
    'your review has already been submitted.',
    'your review has already been submitted',
    'max length was exceeded',
    'please fill out all of the mandatory (*) fields',
    'one or more of your answers does not meet the required criteria',
  ];

  function normalizeNotice(text) {
    return String(text || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function isOnlyYotpoErrorText(text) {
    let rest = normalizeNotice(text);
    if (!rest) return false;
    let changed = true;
    while (changed) {
      changed = false;
      for (const line of YOTPO_ERROR_LINES) {
        if (rest.includes(line)) {
          rest = rest.replace(line, ' ').replace(/\s+/g, ' ').trim();
          changed = true;
        }
      }
    }
    return rest.replace(/[.\-*():]/g, '').trim() === '';
  }

  function hideEmptyReviewNotice(host) {
    if (!host) return;

    qsa('.taupe-yotpo-notice-hidden', host).forEach((el) => {
      el.classList.remove('taupe-yotpo-notice-hidden');
      if (el.querySelector('input, textarea, select, button, label')) {
        el.style.removeProperty('display');
        el.style.removeProperty('visibility');
        el.style.removeProperty('height');
        el.style.removeProperty('overflow');
      }
    });

    qsa('div, span, p, li, small, em, strong, ul, ol', host).forEach((el) => {
      if (el.classList.contains('taupe-yotpo-empty-notice')) return;
      if (el.matches('.yotpo-submit, button, input, textarea, select, label')) return;
      if (el.querySelector('input, textarea, select, button, label, .yotpo-submit')) return;
      const full = normalizeNotice(el.textContent);
      if (!full || !isOnlyYotpoErrorText(full)) return;
      const matchCount = YOTPO_ERROR_LINES.filter((line) => full.includes(line)).length;
      // Only the preloaded dump (many messages at once). Keep a single real submit error.
      if (matchCount < 3) return;
      el.classList.add('taupe-yotpo-empty-notice');
      el.style.setProperty('display', 'none', 'important');
    });
  }

  function isIconEl(el) {
    if (!el || el.nodeType !== 1) return false;
    const cls = String(el.className || '');
    return /yotpo-icon|icon-facebook|icon-google|icon-linkedin|icon-twitter/i.test(cls);
  }

  function polishForm(host) {
    if (!host || polishing) return;
    polishing = true;
    try {
      const font = "'Montserrat', Helvetica, Arial, sans-serif";

      // Uniform Montserrat on real text nodes (skip icon glyphs + our buttons)
      qsa('*', host).forEach((el) => {
        if (isIconEl(el)) return;
        if (el.matches('svg, path, use, .taupe-social-btn, .taupe-social-row')) return;
        el.style.setProperty('font-family', font, 'important');
        if (el.matches('label, .y-label, .yotpo-field-title, p, span')) {
          el.style.setProperty('background', 'transparent', 'important');
        }
      });

      hideEmptyReviewNotice(host);
      hideYotpoBranding(host);
      rebuildSocialButtons(host, font);
      host.dataset.taupePolished = '1';
    } finally {
      polishing = false;
    }
  }

  function networkFromEl(el) {
    const hay = `${el.className || ''} ${el.id || ''} ${el.getAttribute('href') || ''} ${el.getAttribute('aria-label') || ''} ${el.getAttribute('title') || ''}`.toLowerCase();
    if (hay.includes('facebook')) return 'Facebook';
    if (hay.includes('google')) return 'Google';
    if (hay.includes('linkedin')) return 'LinkedIn';
    if (hay.includes('twitter') || hay.includes('x.com')) return 'X';
    return '';
  }

  function rebuildSocialButtons(host, font) {
    // Already built once — do not rebuild (DOM writes would re-fire MutationObserver)
    if (host.querySelector('.taupe-social-row .taupe-social-btn')) return;

    // Yotpo social controls are usually icon-font only (no text). Build our own labeled buttons.
    const iconSelectors = [
      '.yotpo-icon-facebook',
      '.yotpo-icon-google',
      '.yotpo-icon-linkedin',
      '.yotpo-icon-twitter',
      '[class*="yotpo-icon-facebook"]',
      '[class*="yotpo-icon-google"]',
      '[class*="yotpo-icon-linkedin"]',
      '[class*="yotpo-icon-twitter"]',
      'a[href*="facebook.com"]',
      'a[href*="accounts.google"]',
      'a[href*="googleapis.com"]',
      'a[href*="oauth"]',
    ].join(',');

    const found = [];
    const seen = new Set();

    qsa(iconSelectors, host).forEach((el) => {
      if (el.closest('.taupe-social-row')) return;
      const label = networkFromEl(el);
      if (!label) return;
      const clickable =
        el.closest('a, button, [role="button"], .yotpo-icon-btn, .yotpo-default-button') || el;
      if (seen.has(clickable) || clickable.classList.contains('taupe-social-btn')) return;
      seen.add(clickable);
      found.push({ clickable, label });
    });

    if (!found.length) {
      // Fallback: empty clickable bars near CONNECT WITH
      qsa('a, button, .yotpo-icon-btn, [role="button"]', host).forEach((el) => {
        if (el.closest('.taupe-social-row') || seen.has(el)) return;
        if (el.matches('.yotpo-submit, [type="submit"], .write-review, .taupe-social-btn')) return;
        const label = networkFromEl(el);
        if (!label) return;
        seen.add(el);
        found.push({ clickable: el, label });
      });
    }

    if (!found.length) return;

    let row = host.querySelector('.taupe-social-row');
    if (!row) {
      row = document.createElement('div');
      row.className = 'taupe-social-row';

      let anchor = null;
      qsa('div, span, p, label', host).forEach((el) => {
        if (el.closest('.taupe-social-row')) return;
        const t = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        if (t === 'connect with:' || t === 'connect with' || t.startsWith('connect with')) {
          anchor = el;
        }
      });
      if (anchor && anchor.parentElement) {
        anchor.parentElement.insertBefore(row, anchor.nextSibling);
      } else {
        const firstField = host.querySelector('input[type="text"], input[type="email"], textarea');
        if (firstField && firstField.parentElement) {
          firstField.parentElement.insertBefore(row, firstField);
        } else {
          host.appendChild(row);
        }
      }
    }

    found.forEach(({ clickable, label }) => {
      clickable.classList.add('taupe-yotpo-social-hidden');
      clickable.setAttribute('aria-hidden', 'true');
      clickable.style.setProperty('display', 'none', 'important');
      clickable.style.setProperty('visibility', 'hidden', 'important');
      clickable.style.setProperty('position', 'absolute', 'important');
      clickable.style.setProperty('width', '1px', 'important');
      clickable.style.setProperty('height', '1px', 'important');
      clickable.style.setProperty('overflow', 'hidden', 'important');
      clickable.style.setProperty('pointer-events', 'none', 'important');

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'taupe-social-btn';
      btn.textContent = label;
      btn.setAttribute('aria-label', `Connect with ${label}`);

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        try {
          clickable.style.setProperty('pointer-events', 'auto', 'important');
          clickable.click();
        } catch (err) {}
      });

      row.appendChild(btn);
    });
  }

  function closePopup() {
    const popup = document.getElementById('TaupeYotpoPopup');
    const host = document.getElementById('TaupeYotpoPopupFormHost');
    if (!popup || !host) return;

    const form = host.querySelector('[data-taupe-yotpo-home="1"]') || host.firstElementChild;
    if (form && form._taupeHomeMarker?.parentNode) {
      form._taupeHomeMarker.parentNode.insertBefore(form, form._taupeHomeMarker);
      form._taupeHomeMarker.remove();
      form._taupeHomeMarker = null;
      delete form.dataset.taupeYotpoHome;
    }

    qsa('.taupe-yotpo-modal-live').forEach((modal) => {
      modal.classList.remove('taupe-yotpo-modal-live');
    });

    host.querySelectorAll('.taupe-social-row, .taupe-star-picker').forEach((el) => el.remove());
    qsa('.taupe-yotpo-adopted').forEach((el) => el.classList.remove('taupe-yotpo-adopted'));
    delete host.dataset.taupePolished;
    delete host.dataset.taupeStarsBound;
    popup.classList.remove('is-yotpo-native');
    setPostBusy(false);

    setLoading(host, false);
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('taupe-yotpo-popup-open');
    qsa('.taupe-yotpo-modal-spent').forEach((el) => el.classList.remove('taupe-yotpo-modal-spent'));
  }

  function openShell(section) {
    const popup = document.getElementById('TaupeYotpoPopup');
    const host = document.getElementById('TaupeYotpoPopupFormHost');
    if (!popup || !host) return;
    host.querySelectorAll('.taupe-social-row, .taupe-yotpo-popup__error').forEach((el) => el.remove());
    delete host.dataset.taupePolished;
    setLoading(host, true);
    popup.classList.add('is-open');
    popup.classList.remove('is-yotpo-native');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('taupe-yotpo-popup-open');
    section?.classList.add('taupe-yotpo--popup-ready');
  }

  function clickNative(section) {
    const native = findNativeWrite(section);
    if (!native) return false;
    native.classList.add('taupe-yotpo-native-trigger');
    // Ensure it can receive a click even if clipped
    native.style.setProperty('pointer-events', 'auto', 'important');
    try {
      native.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      native.click();
    } catch (e) {
      try {
        native.click();
      } catch (err) {}
    }
    return true;
  }

  function triggerAndOpen(section) {
    openShell(section);
    clickNative(section);

    let attempts = 0;
    const maxAttempts = 25;
    const tick = () => {
      attempts += 1;
      const candidate = findFormCandidate(section);
      if (candidate && adoptIntoPopup(candidate, section)) return;
      if (attempts >= maxAttempts) {
        const host = document.getElementById('TaupeYotpoPopupFormHost');
        setLoading(host, false);
        if (host && fieldCount(host) === 0) {
          let err = host.querySelector('.taupe-yotpo-popup__error');
          if (!err) {
            err = document.createElement('p');
            err.className = 'taupe-yotpo-popup__error';
            err.textContent =
              'The review form could not be loaded. Please refresh the page and try again, or check that Yotpo is enabled.';
            host.appendChild(err);
          }
        }
        return;
      }
      window.setTimeout(tick, 150);
    };
    window.setTimeout(tick, 80);
  }

  function init() {
    const section = document.querySelector('.taupe-yotpo-reviews');
    const popup = document.getElementById('TaupeYotpoPopup');
    const writeBtn = document.getElementById('TaupeYotpoWriteBtn');
    if (!section || !popup || !writeBtn) return;

    popup.querySelectorAll('[data-taupe-yotpo-close]').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        closePopup();
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
    });

    writeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      triggerAndOpen(section);
    });

    hideYotpoBranding(section);
    hideEmptyReviewNotice(section);
    window.setTimeout(() => {
      hideYotpoBranding(section);
      hideEmptyReviewNotice(section);
    }, 800);
    window.setTimeout(() => {
      hideYotpoBranding(section);
      hideEmptyReviewNotice(section);
    }, 2000);

    const observer = new MutationObserver(() => {
      hideYotpoBranding(section);
      hideEmptyReviewNotice(section);
      if (!popup.classList.contains('is-open') || polishing) return;
      const host = document.getElementById('TaupeYotpoPopupFormHost');
      const live = liveFormRoot();
      if (live && fieldCount(live) > 0) {
        setLoading(host, false);
        hideEmptyReviewNotice(live);
        ensureTaupeStars(live);
        hideNativeSubmitButtons(live);
        const needsSocial =
          !live.querySelector('.taupe-social-btn') &&
          !!live.querySelector(
            '.yotpo-icon-facebook, .yotpo-icon-google, [class*="yotpo-icon-facebook"], [class*="yotpo-icon-google"]'
          );
        if (live.dataset.taupePolished !== '1' || needsSocial) polishForm(live);
        return;
      }
      const candidate = findFormCandidate(section);
      if (candidate) adoptIntoPopup(candidate, section);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
